import { call, put, takeLatest, select } from 'redux-saga/effects';

import {
  CASE_SPLIT_DOCUMENT_BEGIN,
  CASE_SPLIT_DOCUMENT_SUCCESS,
  CASE_SPLIT_DOCUMENT_FAILURE,
  CASE_SPLIT_DOCUMENT_DISMISS_FEEDBACK,
  CASE_FETCH_DOCUMENTS_BEGIN,
  CASE_FETCH_FOLDER_BEGIN,
} from './constants';
import {
  createPromiseAction,
  resolvePromiseAction,
  rejectPromiseAction,
} from '@adobe/redux-saga-promise';
import api from 'common/api';
import {
  withCurrentCaseId,
  selectCurrentFolder,
  selectEnableNotifications,
} from '../../../common/selectors';

export const splitDocument = createPromiseAction(CASE_SPLIT_DOCUMENT_BEGIN);

export function dismissSplitDocumentFeedback() {
  return {
    type: CASE_SPLIT_DOCUMENT_DISMISS_FEEDBACK,
  };
}

// worker Saga: will be fired on CASE_SPLIT_DOCUMENT_BEGIN actions
export function* doSplitDocument(action) {
  const {
    payload: { caseId, fileId, targetFolderId, splitFiles },
  } = action;
  const isNotificationEnabled = yield select(selectEnableNotifications);

  try {
    const response = yield call(api.post, `/cases/${caseId}/split/${fileId}`, {
      targetFolderId,
      splitFiles,
    });

    if (response && response.error) {
      yield put({
        type: CASE_SPLIT_DOCUMENT_FAILURE,
        feedback: {
          message: 'feedback.splitDocumentFailure',
          error: response.error,
          retryAction: action,
        },
      });
      return yield call(rejectPromiseAction, action, response);
    }

    const currentFolder = yield select(selectCurrentFolder);

    if (currentFolder && targetFolderId === currentFolder.id) {
      yield put({ type: CASE_FETCH_DOCUMENTS_BEGIN });
      yield put({
        type: CASE_FETCH_FOLDER_BEGIN,
        payload: { folderId: targetFolderId, noPromise: true },
      });
    }

    yield put({
      type: CASE_SPLIT_DOCUMENT_SUCCESS,
      ...(!isNotificationEnabled && {
        feedback: { message: 'feedback.splitDocumentSuccess' },
      }),
    });
    yield call(resolvePromiseAction, action, response);

    return response;
  } catch (error) {
    yield put({
      type: CASE_SPLIT_DOCUMENT_FAILURE,
      feedback: {
        message: 'feedback.splitDocumentFailure',
        error: error,
        retryAction: action,
      },
    });
    return yield call(rejectPromiseAction, action, { error });
  }
}

export function* watchSplitDocument() {
  yield takeLatest(splitDocument, withCurrentCaseId(doSplitDocument));
}

export function reducer(state, action) {
  switch (action.type) {
    case CASE_SPLIT_DOCUMENT_BEGIN + '.TRIGGER':
      return {
        ...state,
        splitDocumentPending: true,
        splitDocumentFeedback: null,
      };

    case CASE_SPLIT_DOCUMENT_SUCCESS:
      return {
        ...state,
        splitDocumentPending: false,
        splitDocumentFeedback: action.feedback,
      };

    case CASE_SPLIT_DOCUMENT_FAILURE:
      return {
        ...state,
        splitDocumentPending: false,
        splitDocumentFeedback: action.feedback,
      };

    case CASE_SPLIT_DOCUMENT_DISMISS_FEEDBACK:
      return {
        ...state,
        splitDocumentFeedback: null,
      };

    default:
      return state;
  }
}
